/**
 * Blog sidebar Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/template-blog.liquid
 *
 */

import debounce from 'lodash-es/debounce';
import algoliasearch from 'algoliasearch/lite';
 
 export default {
     components: {
     },
 
     props: {
        defaultValue: {
            type: String,
            default: null
        },
        isSearchOpen: {
            type: Boolean
        }
    },

    directives: {
        clickOutside: {
            bind: function (element, binding, vnode) {
                element.clickOutsideEvent = function (event) {  //  check that click was outside the el and his children
                  if (!(element === event.target || element.contains(event.target))) { // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                    // binding.value(); run the arg
                  }
                };
                document.body.addEventListener('click', element.clickOutsideEvent)
            },
            unbind: function (element) {
                document.body.removeEventListener('click', element.clickOutsideEvent)
            }
        }
    },
 
     data() {
         return {
            isLoading: false,
            searchClient: null,
            isResultsShown: false,
            algoliaConfig: window.algoliaShopify.config,
            search: null,
            articleResults: [],
            blogFilterShow: false
         }
     },
 
     watch: {

        search(value) {
            this.isLoading = true;
            if (value) {
                this.isResultsShown = true;
                this.debouncedPerformSearch();
                
            } else {
                this.isResultsShown = false;
                this.results = [];
                this.isLoading = false;
            }
        }

    },

 
     mounted() {
        this.searchClient = algoliasearch(
            this.algoliaConfig.app_id,
            this.algoliaConfig.search_api_key
        );
        this.debouncedPerformSearch = debounce(this.performSearch, 500);
     },
 
     methods: {

        async performSearch() {

            const queries = [
                
                {
                    indexName: this.algoliaConfig.index_prefix + 'articles',
                    query: this.search,
                    params: {
                        hitsPerPage: 10,
                        getRankingInfo: true
                    }
                }
            ]         

            if(this.search.length > 0) {
                this.searchClient.search(queries, (err, { results } = {}) => {

                }).then((response) => {

                    this.articleResults = response.results[0].hits;
    
                }).catch((error) => {
                    console.log(error);
                }).then(() => {
                    this.isLoading = false;
                });
            } else {
                this.articleResults = [];
            }
           
        },

        hideResults() {
            this.isResultsShown = false;
        },

        toggleFilters() {
            this.blogFilterShow = !this.blogFilterShow;
        }
 

     }
 }